import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faUniversity,
  faGavel,
  faCity,
  faBuilding,
  faTachometerAlt,
  faUser,
  faList,
  faClipboardCheck,
  faForward,
  faPencilAlt,
  faTrashAlt,
  faSave,
  faTimes,
  faClipboardList,
  faLayerGroup,
  faBook,
  faHome,
  faFileAlt,
  faFileSignature,
  faPlusCircle,
  faCaretRight,
  faEye,
  faUserShield,
  faChevronLeft,
  faCheck,
  faCheckSquare,
  faHeartbeat,
  faLaptopMedical,
  faReply,
  faFilter,
  faDownload,
  faArrowRight,
  faFileContract,
  faInfoCircle,
  faCopy as fasFaCopy,
  faUpload,
  faUndoAlt,
  faUserEdit,
  faLightbulb,
  faExclamationTriangle,
  faCircle,
  faUsers,
  faUserFriends,
  faBox,
  faUserMd,
  faBriefcaseMedical,
  faFileMedicalAlt,
  faShareAltSquare,
  faBan,
  faFirstAid,
  faNotesMedical,
  faAngleDown,
  faSlidersH,
  faShareAlt,
  faFileMedical,
  faPrescriptionBottleAlt,
  faPlayCircle,
  faListAlt,
  faProcedures,
  faCalendarDay,
  faUserCheck,
  faArrowLeft,
  faMobileAlt,
  faAt,
  faCalendarAlt,
  faBriefcase,
  faThumbsUp,
  faMapMarkedAlt,
  faCashRegister,
  faWallet,
  faEnvelope,
  faCoins,
  faBalanceScaleRight,
  faBell,
  faClock,
  faHandHoldingUsd,
  faTags,
  faChartLine,
  faReceipt,
  faStickyNote,
  faAngleLeft,
  faUserPlus,
  faTimesCircle,
  faUserTimes,
  faSignInAlt,
  faPaperPlane,
  faMobile,
  faFileInvoiceDollar,
  faSpinner,
  faHourglassHalf,
  faPrint,
  faLandmark,
  faCogs,
  faTruckLoading,
  faCalendar,
  faCalculator,
  faBalanceScale,
  faUserGraduate,
  faGraduationCap,
  faSchool,
  faIdBadge,
  faCubes,
  faRulerHorizontal,
  faBoxes,
  faCog,
  faEraser
} from '@fortawesome/free-solid-svg-icons';

import {
  faCopy as farFaCopy,
  faFileAlt as farFile,
  faFilePdf,
  faFileExcel,
  faFileVideo,
  faFileAudio,
  faFileWord,
  faFileImage,
  faCalendarAlt as farCalendarAlt,
  faCalendarCheck as farCalendarCheck,
  faEnvelope as farEnvelope,
  faTimesCircle as farTimesCircle,
  faCheckCircle as farCheckCircle
} from '@fortawesome/free-regular-svg-icons';

import {
  faCcVisa,
  faCcMastercard,
  faCcDinersClub,
  faCcAmex,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';

library.add(
  fasFaCopy,
  farFaCopy,
  faUniversity,
  faGavel,
  faCity,
  faBuilding,
  faTachometerAlt,
  faUser,
  faList,
  faClipboardCheck,
  faForward,
  faPencilAlt,
  faTrashAlt,
  faSave,
  faTimes,
  faClipboardList,
  faLayerGroup,
  faBook,
  faHome,
  faFileAlt,
  faFileSignature,
  faEye,
  faInfoCircle,
  faPlusCircle,
  faCaretRight,
  faUserShield,
  faChevronLeft,
  faCheck,
  faCheckSquare,
  faReply,
  faFilter,
  faDownload,
  faArrowRight,
  faUpload,
  faFileContract,
  faUndoAlt,
  faUserEdit,
  faLightbulb,
  faExclamationTriangle,
  faCircle,
  farFile,
  faUsers,
  faUserFriends,
  faBox,
  faUserMd,
  faBriefcaseMedical,
  faShareAltSquare,
  faFileMedicalAlt,
  faBan,
  faFirstAid,
  faNotesMedical,
  faAngleDown,
  faSlidersH,
  faFilePdf,
  faFileExcel,
  faFileVideo,
  faFileAudio,
  faFileWord,
  faFileImage,
  faShareAlt,
  faFileMedical,
  faPrescriptionBottleAlt,
  faPlayCircle,
  faListAlt,
  faProcedures,
  farCalendarAlt,
  farCalendarCheck,
  faCalendarDay,
  faUserCheck,
  faArrowLeft,
  faMobileAlt,
  faAt,
  faCalendarAlt,
  faHeartbeat,
  faLaptopMedical,
  faBriefcase,
  faThumbsUp,
  faCcVisa,
  faCcMastercard,
  faCcDinersClub,
  faCcAmex,
  faMapMarkedAlt,
  faCashRegister,
  faWallet,
  faEnvelope,
  faCoins,
  faBalanceScaleRight,
  faBell,
  faClock,
  faHandHoldingUsd,
  faTags,
  faChartLine,
  faReceipt,
  faStickyNote,
  faAngleLeft,
  faUserPlus,
  faTimesCircle,
  faUserTimes,
  faSignInAlt,
  faPaperPlane,
  faWhatsapp,
  faMobile,
  farEnvelope,
  faFileInvoiceDollar,
  faSpinner,
  faHourglassHalf,
  faPrint,
  farTimesCircle,
  faLandmark,
  faCogs,
  faTruckLoading,
  faCalendar,
  faCalculator,
  faBalanceScale,
  farCheckCircle,
  faUserGraduate,
  faGraduationCap,
  faSchool,
  faIdBadge,
  faCubes,
  faRulerHorizontal,
  faBoxes,
  faCog,
  faEraser
);
